export const taskStatusColor = {
"init":"#ddd",
"ready":"rgb(255 188 71)",
"running":"#47FF7B",
"stopped":"rgb(255 188 71)",
"completed":"rgb(71 181 255)",
"terminated":"rgb(99 99 99)",
"failed":"rgb(255 71 71)"
}